export const WordStateParserFunction = (input: string): string => {
    let rez = "";
    let currentWord = "";
    let cijela = false;
    let slash = false;
    let sumprod = false;
    let integral = false;
    let logaritam=false;
    const stack = new Stack<string>();
    const zStack = new Stack<number>();
    for (let i = 0; i < input.length; i++) {
        const sign: string = input[i] ?? '';
        if (sign === " ") {
            rez += sign;
            continue;
        }
        currentWord += sign;
        if (sign === "\\") {
            if (i !== 0 && /[0-9]/.test(input[i-1] ?? '')) {
                cijela = true;
            }
            slash = true;
            continue;
        }
        if (currentWord.length === 1) {
            if (zagrade.has(currentWord)) {
                if (currentWord === "}") {
                    if (stack.peek() === "\\raz" || stack.peek() === "\\draz") {
                        let num = zStack.peek() || 0;

                        if (num === 1) {
                            rez += " i nazivnikom ";
                            zStack.pop();
                            zStack.push(num - 1);
                        }
                        if (num === 0) {
                            zStack.pop();
                            stack.pop();
                        }
                    } else {
                        stack.pop();
                    }
                } else if (currentWord === "]") {
                    if (stack.peek() === "\\kor[") {
                        rez += " od ";

                    }
                }

                rez += zagrade.get(currentWord) || "";

                currentWord = "";
                continue;

            } else if (znakovi.has(currentWord)) {
                stack.push(currentWord);
                if (sumprod) {
                    rez += znakoviSP.get(currentWord) || "";
                    if (currentWord === "^") {
                        sumprod = false;
                    }
                }else if (integral){
                    rez += znakoviIntegral.get(currentWord) || "";
                    if (currentWord === "^") {
                        integral = false;
                    }
                }
                else if (logaritam) {
                    rez += " s bazom ";
                    logaritam = false;
                } else {
                    rez += znakovi.get(currentWord) || "";
                }
                currentWord = "";
                continue;
            } else if (wordDictCommon.has(currentWord)) {
                if (input[i + 1] === "=") {
                    continue;
                }
                rez += wordDictCommon.get(currentWord) || "";
                currentWord = "";
                continue;
            } else if (stupnjevi.has(currentWord)) {
                rez += stupnjevi.get(currentWord) || "";
                currentWord = "";
                continue;
            } else {
                rez += currentWord;
                currentWord = "";
                continue;
            }
        } else if (currentWord.length === 3 || currentWord.length === 2) {
            if (slash && zagrade2.has(currentWord)) {
                rez += zagrade2.get(currentWord) || "";

                slash = false;
                currentWord = "";
                continue;
            }
            if (wordDict2.has(currentWord)) {
                rez += wordDict2.get(currentWord) || "";
                currentWord = "";
                slash = false;
                continue;
            }
            if (greekAlphabet.has(currentWord)) {
                rez += greekAlphabet.get(currentWord) || "";
                currentWord = "";
                slash = false;
                continue;
            }
        }
        else if (currentWord.length >= 4) {
            if (wordDict.has(currentWord)) {
                if (currentWord === "\\sum" || currentWord === "\\prod") {
                    sumprod = true;
                }
                if (currentWord === "\\log") {
                    logaritam = true;
                }
                if (currentWord === "\\int" && input[i + 1] === "_") {
                    integral = true;
                }
                if (currentWord === "\\raz" || currentWord === "\\draz") {
                    if (cijela) {
                        rez += " cijela i ";
                        cijela = false;
                    }
                    zStack.push(1)
                } else if (currentWord === "\\kor") {
                    if (input[i + 1] === "[") {
                        continue;
                    }
                }
                let word = wordDict.get(currentWord) || "";
                stack.push(currentWord);

                rez += word;
                slash = false;
                currentWord = "";
                continue;
            }
            if (greekAlphabet.has(currentWord)) {
                rez += greekAlphabet.get(currentWord) || "";
                currentWord = "";
                slash = false;
                continue;
            }
        }
    }

    rez = rez.replace(/\s+/g, ' ');
    return rez.trim();
};
let stupnjevi = new Map<string, string>([
    ["º", " stupnjeva "],
])
let znakovi = new Map<string, string>([
    ["^", " na "],
    ["_", " s indeksom "],
])
let znakoviSP = new Map<string, string>([
    ["^", " do "],
    ["_", " s indeksom od"],
])
let znakoviIntegral = new Map<string, string>([
    ["^", " i gornjom granicom "],
    ["_", " s donjom granicom"],
])
let zagrade = new Map<string, string>([
    ["(", " otvorena zagrada "],
    [")", " zatvorena zagrada "],
    ["{", " "],
    ["}", " "],
    ["[", " "],
    ["]", " "],


]);
let zagrade2 = new Map<string, string>([
    ["\\{", " otvorena vitičasta zagrada "],
    ["\\}", " zatvorena vitičasta zagrada "],
    ["\\[", " otvorena uglata zagrada "],
    ["\\]", " zatvorena uglata zagrada "],
]);
let wordDictCommon = new Map<string, string>([
    ["+", " plus "],
    ["-", " minus "],
    ["*", " puta "],
    [":", " dijeljeno "],
    ["=", " jednako "],
    ["%", " posto "],
    ["<", " manje od "],
    [">", " veće od "],
    ["'", " apostrof "],

]);

let wordDict = new Map<string, string>([
    ["\\kor", "korijen od "],
    ["\\kor[", "korijen stupnja "],
    ["\\raz", "razlomak s brojnikom "],
    ["\\draz", "razlomak s brojnikom "],
    ["\\sin", " sinus "],
    ["\\cos", " kosinus "],
    ["\\tan", " tangens "],
    ["\\cot", " kotangens "],
    ["\\arcsin", " arkus sinus "],
    ["\\arccos", " arkus kosinus "],
    ["\\arctan", " arkus tangens "],
    ["\\arccot", " arkus kotangens "],
    ["\\nej", "nije jednako "],
    ["\\uni", " unija "],
    ["\\pre", " presjek "],
    ["\\nel", " nije element od "],
    ["\\besk", " beskonačno "],
    ["\\konj", " konjugirano "],
    ["\\disj", " disjunktno "],
    ["\\ekv", " ekvivalentno "],
    ["\\pods", " podskup od "],
    ["\\kontra", " je kontradiktorno "],
    ["\\paralel", " je paralelno "],
    ["\\trokut", " trokut "],
    ["\\kut", " kut "],
    ["\\impl", " implicira "],
    ["\\sklad", " je skladan s "],
    ["\\sum", " suma "],
    ["\\prod", " produkt "],
    ["\\int", " integral "],
    ["\\log", " logaritam "],
    ["\\lim", " limes "],
    ["\\vek", " vektor "],
    ["\\crta", " periodično "],
    


]);

let wordDict2 = new Map<string, string>([
    ["<=", " manje ili jednako "],
    [">=", " veće ili jednako "],
    ["\\el", " element od "],
    ["\\:", " dvotočka "],
    ["\\mp", " minus plus "],
    ["\\pm", " plus minus "],
    ["\\ln", " prirodni logaritam "],
]);

let greekAlphabet = new Map<string, string>([
    ["\\alfa", " alfa "],
    ["\\beta", " beta "],
    ["\\gama", " gama "],
    ["\\delta", " delta "],
    ["\\epsilon", " epsilon "],
    ["\\zeta", " zeta "],
    ["\\eta", " eta "],
    ["\\theta", " theta "],
    ["\\jota", " jota "],
    ["\\kapa", " kapa "],
    ["\\lambda", " lambda "],
    ["\\mi", " mi "],
    ["\\ni", " ni "],
    ["\\ksi", " ksi"],
    ["\\omikron", " omikron "],
    ["\\pi", " pi "],
    ["\\ro", " ro "],
    ["\\sigma", " sigma "],
    ["\\tau", " tau "],
    ["\\ipsilon", " ipsilon "],
    ["\\fi", " fi "],
    ["\\hi", " hi "],
    ["\\psi", " psi "],
    ["\\omega", " omega "],
    ["\\Alfa", " alfa "],
    ["\\Beta", " beta "],
    ["\\Gama", " gama "],
    ["\\Delta", " delta "],
    ["\\Epsilon", " epsilon "],
    ["\\Zeta", " zeta "],
    ["\\Eta", " eta "],
    ["\\Theta", " theta "],
    ["\\Jota", " jota "],
    ["\\Kapa", " kapa "],
    ["\\Lambda", " lambda "],
    ["\\Mi", " mi "],
    ["\\Ni", " ni "],
    ["\\Ksi", " ksi"],
    ["\\Omikron", " omikron"],
    ["\\Pi", " pi"],
    ["\\Ro", " ro"],
    ["\\Sigma", " sigma"],
    ["\\Tau", " tau"],
    ["\\Ipsilon", " ipsilon"],
    ["\\Fi", " fi"],
    ["\\Hi", " hi"],
    ["\\Psi", " psi"],
    ["\\Omega", " omega"],
]);

class Stack<T> {
    private items: T[] = [];

    // Push an item onto the stack
    push(item: T): void {
        this.items.push(item);
    }

    // Pop an item off the stack
    pop(): T | undefined {
        return this.items.pop();
    }

    // Peek at the top item without removing it
    peek(): T | undefined {
        return this.items[this.items.length - 1];
    }

    // Check if the stack is empty
    isEmpty(): boolean {
        return this.items.length === 0;
    }

    // Get the size of the stack
    size(): number {
        return this.items.length;
    }

    // Clear the stack
    clear(): void {
        this.items = [];
    }
}